import { WisWizAPI, WisWizAPIError } from "@/services/api";
import * as Sentry from "@sentry/nextjs";

export const SLUG_PATTERN = /^[a-z0-9_]+$/;
export const MAX_SLUG_LENGTH = 255;

export async function flushInfluencerAttribution(api: WisWizAPI) {
  try {
    const ref = sessionStorage.getItem("influencer_ref");
    if (ref && ref.length <= MAX_SLUG_LENGTH && SLUG_PATTERN.test(ref)) {
      await api.setInfluencerAttribution(ref);
      try { sessionStorage.removeItem("influencer_ref"); } catch {}
    }
  } catch (err) {
    // Clear sessionStorage on 404 (deleted slug) to prevent infinite retry on every login
    if (err instanceof WisWizAPIError && err.statusCode === 404) {
      try { sessionStorage.removeItem("influencer_ref"); } catch {}
    }
    Sentry.captureException(err, { extra: { context: "influencer_attribution_flush" } });
  }
}
